import { Authentication, User } from '../types'

export const canGenerateTokens = ({ user, authentication }: { user?: User; authentication?: Authentication }) => {
  // Check if the user is the same
  if (user?.referenceId === authentication?.referenceId) {
    return true
  }

  // Check permissions
  if (!authentication?.roles) {
    return false
  }

  return (
    authentication.roles
      .map((roleForClinic) => roleForClinic.role)
      .flatMap((role) => role.applicationPermissions)
      .find((permission) => permission.application === 'HADES' && permission.view === 'USER_IMPERSONATE') || false
  )
}
